<template class="table-empty">
    <tr>
        <td class="text-align-center" :colspan="colSpan">
            <div class="jumbotron" v-if="!component">
                <h4><i class="fa fa-meh-o"></i> {{ primaryMessage ? primaryMessage : "No Data Found." }}</h4>
            </div>
            <div class="container mt-3 text-center" v-if="component">
                <p class="lead">{{ secondaryMessage ? secondaryMessage : "Try refining your search criteria." }}</p>
            </div>
        </td>
    </tr>
</template>

<style lang="scss" src="./TableEmpty.scss"></style>

<script lang="ts" src="./TableEmpty.ts"></script>
